import React, { Component } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Slide,
    Box,
    TextField,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { ShowAlert } from "../../Component/ShowAlert";
import UserDetailsService from "../../Services/UserDetailsService";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Interface definitions...
interface BlockUnblockStatusUpdateProps {
    open: boolean;
    accessToken: string;
    selectedData: any;
    onClose?: (state: boolean, action: string) => void;
    refreshData: () => void;
    stausName: string;
    statusCode: number;
}

interface BlockUnblockStatusUpdateState {
    _id: string;
    status: number;
    stausName: string;
    note: string;
    noteError: boolean;
}

class BlockUnblockStatusUpdate extends Component<BlockUnblockStatusUpdateProps, BlockUnblockStatusUpdateState> {
    constructor(props: BlockUnblockStatusUpdateProps) {
        super(props);
        const { selectedData, statusCode, stausName } = props;
        this.state = {
            _id: selectedData?.user_id || "",
            status: statusCode,
            stausName: stausName,
            note: selectedData.admin_comment ?? "", 
            noteError: false,
        };
    }

    handleNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ note: e.target.value, noteError: false });
    };

    handleUpdateStatus = async () => {
        const { accessToken, refreshData, onClose } = this.props;
        const { _id, status, stausName, note } = this.state;

        if (note.trim() === '') {
            this.setState({ noteError: true });
            return;
        }

        let postdata = {
            "userId": _id,
            "userStatus": status,
            "adminComment": note.trim()
        }

        let resp = await UserDetailsService.UpdateUserStatus(accessToken, postdata);

        if (resp.ok) {
            onClose?.(true, "ok");

            ShowAlert("Success", `The user has been marked as ${stausName}.`, 'success').then(() => {
                refreshData();
            });
        } else {
            ShowAlert("Error", "Failed to update user status.", "error");

        }
    };

    render() {
        const { open, onClose } = this.props;
        const { note, noteError } = this.state;

        return (
            <Dialog
                open={open}
                onClose={() => onClose?.(false, "cancel")}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
            >
                <DialogTitle>Update Status</DialogTitle>
                <DialogContent>
                    <Box mt={1} display="flex" flexDirection="column" gap={2}>
                        <TextField
                            label="Reasons / Comments (required)"
                            multiline
                            minRows={3}
                            value={note}
                            onChange={this.handleNoteChange}
                            variant="outlined"
                            fullWidth
                            placeholder="Enter your comments for status update"
                            error={noteError}
                            helperText={noteError ? "Admin comment is required." : ""}
                            inputProps={{ maxLength: 100 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClose?.(false, "cancel")}>
                        Cancel
                    </Button>
                    <Button onClick={this.handleUpdateStatus} color="secondary" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default BlockUnblockStatusUpdate;
